<script setup lang="ts">
import { Badge } from '~ds/components/ui/badge';
import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <Badge
    as="span"
    variant="outline"
  >
    <Icon
      :name="ICONS.favouriteSolid"
      size="sm"
      class="shrink-0"
    />
    {{ t('unified.common.saved') }}
  </Badge>
</template>
